import React, { Suspense } from 'react';

export const FinanceIntakeComponent = React.lazy(() => import('./FinanceIntake'));

export const FinanceIntake = () => (
  <Suspense fallback={null}>
    <FinanceIntakeComponent />
  </Suspense>
);
